import { createMuiTheme } from '@material-ui/core/styles'
import { heading } from '../../utils/utils'

const mainFont = 'Poppins, sans-serif'

const white = '#fff'
const black = '#000'
const primaryMain = '#738C86' //vert clair
const primaryLight = '#FFFAF5' //beige qui est la couleur de fond
const secondaryMain = '#5C706B' //vert plus fonce
const greyLight = '#F7F7F9' //variable d'origine grise (pour divider par exemple)
const imp = '!important'
const disabledColor = '#0000001f'
/*
Variables d'origines
const primaryMain = '#00233A'
const primaryLight = '#E5E9EB'
const secondaryMain = '#B4D2C1'
const greyLight = '#F7F7F9'
*/

// const f11 = `11px`
const f12 = `12px`
const f13 = `13px`
const f14 = `14px`
const f15 = `15px`
const f16 = `16px`
const f18 = `18px`

// const f20 = `20px`
// const f22 = `22px`
const f24 = `24px`
// const f30 = `30px`
const f32 = `32px`

const body = {
  fontSize: f14,
  lineHeight: 1.6,
}
const body2 = {
  fontSize: f13,
  lineHeight: 1.67,
}

const theme = createMuiTheme({
  themeFont: {
    //WARNING FONT NAME WITH SPACE SHOULD HAVE A +. NEXT JS TRIGGER BAD URL FOR GOOGLE FONT
    main: 'Hanken+Grotesk',
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 480,
      md: 768,
      lg: 1024,
      xl: 1440,
    },
  },
  typography: {
    fontFamily: `${mainFont}`,
    h1: {
      lineHeight: 1.15,
      ...heading(f32, f32, 700, 700, mainFont, mainFont, false),
      textTransform: 'uppercase',
    },
    h2: {
      lineHeight: 1.15,
      ...heading(f24, f24, 600, 700, mainFont, mainFont, false),
    },
    h3: {
      lineHeight: 1.4,
      ...heading(f18, f18, 700, 700, mainFont, mainFont, false),
    },
    h4: {
      lineHeight: 1.55,
      ...heading(f16, f16, 700, 700, mainFont, mainFont, false),
    },
    h5: {
      lineHeight: 1.25,
      ...heading(f14, f14, 600, 700, mainFont, mainFont, false),
    },
    h6: {
      lineHeight: 1.25,
      ...heading(f12, f12, 600, 700, mainFont, mainFont, false),
    },
    body1: {
      ...body,
    },
    body2: {
      ...body2,
    },
    caption: {
      fontSize: f12,
      lineHeight: 1.17,
      fontWeight: 400,
    },
    button: {
      fontSize: f15,
      lineHeight: 1.67,
      textTransform: 'inherit',
    },
  },
  palette: {
    common: {
      black: primaryMain,
      white: white,
    },
    background: {
      default: primaryLight,
      paper: white,
    },
    primary: {
      main: primaryMain,
    },
    secondary: {
      main: secondaryMain,
    },
    success: {
      main: '#47E169',
    },
    error: {
      main: '#FA3232',
    },
    warning: {
      main: '#FF8333',
    },
    divider: greyLight,
    primaryTransparent: {
      main: primaryMain,
      light: primaryLight,
    },
    secondaryTransparent: {
      main: primaryMain,
      light: primaryLight,
    },
    ternary: {
      main: '#0082C3',
      light: '#F1FAFF',
    },
    accent: {
      main: '#FFEA28',
    },
  },
  sizes: {
    headerHeight: 60,
    headerHeightTransparent: 90,
    logoWidth: 110,
    logoHeight: 30,
    footerBG: 168,
    basketWidth: 340,
    basketWidthLG: 440,
  },
  extraColors: {
    grey: '#D5D2D9',
    greyLight: '#F5F3F8',
    greyMedium: '#C0BCC6',
    greyText: '#6F677B',
  },
  shadows: [
    'none',
    '0px 0px 15px rgba(46, 46, 46, 0.1)',
    '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
    '0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)',
    '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)',
    '0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)',
    '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)',
    '0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)',
    '0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)',
    '0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)',
    '0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)',
    '0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)',
    '0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)',
    '0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)',
    '0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)',
    '0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)',
    '0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)',
    '0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)',
    '0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)',
    '0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)',
    '0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)',
    '0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)',
    '0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)',
    '0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)',
    '0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)',
  ],
  spacing: 8,
  shape: {
    borderRadius: 4,
  },
  overrides: {
    MuiButton: {
      root: {
        padding: '12px 45px',
        borderRadius: 4,
      },
      sizeSmall: {
        padding: '4px 16px',
        lineHeight: 1.6,
      },
      sizeLarge: {
        padding: '12px 45px',
      },
      contained: {
        boxShadow: 'none',
        '&:hover, &:focus, &:active, &.selected': {
          boxShadow: 'none',
        },
      },
      outlined: {
        padding: '12px 45px',
      },
      outlinedSizeLarge: {
        padding: '12px 45px',
      },
      outlinedSizeSmall: {
        padding: '4px 16px',
        lineHeight: 1.6,
      },
    },
    MuiPaper: {
      root: {
        boxShadow: '0px 0px 15px rgba(46, 46, 46, 0.1)',
      },
      rounded: {
        borderRadius: 4,
      },
    },
    MuiSelect: {
      root: {
        color: primaryMain,
      },
      selectMenu: {
        '&:focus': {
          background: white,
        },
      },
    },
    MuiChip: {
      root: {
        borderRadius: 0,
        fontSize: 15,
        fontWeight: 700,
        color: black,
        backgroundColor: 'transparent',
        height: 25,
        padding: 0,
      },
      label: {
        padding: 0,
      },
      sizeSmall: {
        height: 22,
        fontSize: 12,
        fontWeight: 400,
      },
      labelSmall: {
        paddingLeft: 10,
        paddingRight: 10,
      },
      colorPrimary: {
        color: primaryMain,
        backgroundColor: 'transparent',
      },
      colorSecondary: {
        color: secondaryMain,
        backgroundColor: 'transparent',
      },
    },
    MuiCssBaseline: {
      '@global': {
        '.header': {
          backgroundColor: `${secondaryMain} !important`,
          color: `${primaryLight} !important`,
          '& span,& p,& svg,& a': {
            color: `${primaryLight} !important`,
          },
          '&__logo': {
            width: '150px !important',
            height: 'auto !important',
          },
          '& .menu__submenu': {
            backgroundColor: `${secondaryMain} !important`,
          },
        },

        '.banner': {
          backgroundColor: `${secondaryMain} !important`,
          '& p': {
            color: primaryLight,
          },
        },

        '.footer__bottomRow1Col': {
          '& a button': {
            padding: '8px 24px !important',
          },
        },

        '.section-discover': {
          '&__subtitle': {
            color: `${primaryMain} !important`,
          },
          '& p': {
            color: `${white} !important`,
          },
          '& #swiper-products__prev svg,& #swiper-products__next svg': {
            color: `${secondaryMain} !important`,
          },
          '& .discover-product__content': {
            '& h2,& span': {
              color: `${secondaryMain} !important`,
            },
          },
        },

        '.section-faq': {
          '&__cta': {
            '& p': {
              margin: '0 !important',
            },
          },
          '& .faq__btn': {
            color: `${white} !important`,
          },
          '& .faq__question': {
            '& .paragraph-class': {
              color: `${primaryLight} !important`,
            },
            '&[aria-expanded=true]': {
              '& p': {
                color: `${primaryLight} !important`,
              },
            },
          },
          '& .faq__answer': {
            '& p': {
              color: `${primaryLight} !important`,
            },
          },
          '& .section-faq__cta': {
            backgroundColor: `${primaryLight} !important`,
            '& span,& p': {
              color: `${secondaryMain} !important`,
            },
          },
        },

        '.sizes__btn': {
          '&:hover span': {
            color: `${primaryLight} !important`,
          },
        },
        '.sizes__btn.selected': {
          '& span': {
            color: `${primaryLight} !important`,
          },
        },

        '.sizes-add__btn': {
          '&.MuiButton-containedSecondary': {
            backgroundColor: `${primaryMain} ${imp}`,
            '& span': {
              color: `${white} ${imp}`,
            },
            '&:hover, &:focus, &.selected': {
              backgroundColor: `${secondaryMain} ${imp}`,
              '& span': {
                color: `${white} ${imp}`,
              },
            },
            '&.Mui-disabled': {
              backgroundColor: `${disabledColor} ${imp}`,
              '& span': {
                color: `${secondaryMain} ${imp}`,
              },
            },
          },
        },

        '.faq-page': {
          backgroundColor: `${primaryLight} !important`,
          '&__anchor': {
            padding: '4px 8px !important',
          },
        },

        '.section-hiw': {
          '&__title': {
            fontSize: '30px',
            '& p': {
              margin: '0 !important',
            },
          },
          '&__spacing': {
            padding: '32px 0px !important',
          },
          '&__cta': {
            backgroundColor: `${primaryLight} !important`,
            color: `${secondaryMain} !important`,
          },
        },

        '.hiw': {
          '&__title': {
            fontSize: '20px',
          },
        },

        '.title': {
          color: `${white} !important`,

          '& p': {
            fontSize: '24px !important',
          },
        },

        '.tagline': {
          color: `${white} !important`,
          fontStyle: 'italic',
          fontSize: '13px !important',
        },

        '.contact-page,.account': {
          backgroundColor: `${primaryLight} !important`,
          color: `${primaryMain} !important`,
        },
        '.MuiDialog-paper': {
          backgroundColor: `${secondaryMain} !important`,
        },
        '.search_input_container': {
          backgroundColor: `${primaryLight} !important`,
        },
        '.checkout': {
          backgroundColor: `${secondaryMain} !important`,
        },
        '.shop': {
          '&__planner': {
            backgroundColor: `${secondaryMain} !important`,
            '& .daterange__submit': {
              backgroundColor: `${primaryLight} !important`,
              color: `${secondaryMain} !important`,
            },
            '& svg,& p,& span': {
              color: `${secondaryMain} !important`,
            },
            '& .shipping-infos': {
              '& p,& span': {
                color: `${secondaryMain} !important`,
              },
            },
          },
        },
        'section[class*="__content"]': {
          backgroundColor: `${primaryLight} !important`,
        },
        '.product__breadcrumbs': {
          color: `${primaryLight} !important`,
          '& li,& span,& a': {
            color: `${secondaryMain} !important`,
          },
        },
        '.page--home,.page--product': {
          backgroundColor: `${secondaryMain} !important`,
          '& :is(p,h1,h2,h3,h4):not(.product__short-description *):not(.product-accordions *)':
            {
              color: `${primaryLight} !important`,
            },
        },
        '.hero--shop,.product__content': {
          backgroundColor: `${primaryLight} !important`,
        },
        '.page--product': {
          '& .glider-contain svg': {
            color: `${secondaryMain} !important`,
          },
          '& .availability-checker__link': {
            color: `${white} !important`,
          },

          '& .product__amount': {
            color: `${secondaryMain} !important`,
          },

          '& div:not(.product__short-description, .product__short-description *)':
            {
              color: `${secondaryMain} !important`,
            },
          '& .quantitySelector__total': {
            color: `${secondaryMain} !important`,
          },
        },
        '.cart': {
          backgroundColor: `${secondaryMain} !important`,
          color: `${primaryLight} !important`,
          '& .cart-item': {
            color: `${secondaryMain} !important`,
          },
        },
        '.shipping__note, .price__amount, .price__duration': {
          color: `${secondaryMain} !important`,
        },
        '.product__right': {
          '& p,& span': {
            color: `${secondaryMain} !important`,
          },
        },
        '.product__head': {
          '& h1,& h2,& h3,& h4': {
            color: `${secondaryMain} !important`,
          },
        },
        '.productCard__desc': {
          '& h2,& div,& .price__amount,& .price__duration': {
            color: `${secondaryMain} !important`,
          },
        },
      },
    },
  },
})

export default theme
